export default {
  PROJECT_UNIT_LAYOUTS_SET_LOADING: 'PROJECT_UNIT_LAYOUTS_SET_LOADING',

  PROJECT_UNIT_LAYOUTS_REQUEST: 'PROJECT_UNIT_LAYOUTS_REQUEST',
  PROJECT_UNIT_LAYOUTS_FAILURE: 'PROJECT_UNIT_LAYOUTS_FAILURE',
  PROJECT_UNIT_LAYOUTS_SUCCESS: 'PROJECT_UNIT_LAYOUTS_SUCCESS',

  PROJECT_UNIT_LAYOUTS_RESET: 'PROJECT_UNIT_LAYOUTS_RESET',
};
